import React from 'react';
import classnames from 'classnames';
import CheckIcon from '../../../../../images/svg/icons8-checkmark-solid';
import { IProgressItem } from '../progress-bar/progress-bar';

import './circle-checkbox.scss';

type IProgressItemCheckbox = Omit<IProgressItem, 'type'>;

interface IProps {
    item: IProgressItemCheckbox;
    handleClick: (e) => void;
    size?: number;
    className?: string;
}

const CircleCheckbox = (props: IProps) => {
    const { item, handleClick, size, className } = props;
    const { active, status, disabled = false, } = item;
    return (
        <div
            className={classnames('step', className, {
                'step__active': active,
                'step__disabled': disabled
            })}
            style={size && { width: `${size}px`, height: `${size}px` }}
            data-value={status}
            data-default={item.default}
            onClick={handleClick}
        >
            {active &&
                <div className='step__checkmark'>
                    <CheckIcon />
                </div>
            }
        </div>
    );
};

export { CircleCheckbox };

